/* tslint:disable */
/* eslint-disable */
/* @relayHash 0021e1be4e4552f8ea59d709947e2685 */

import { ConcreteRequest } from "relay-runtime";
export type UserAddAddressInput = {
    userId: string;
    validateBuyerShipping?: boolean | null;
    address: AddressInput;
    mockAddressBook?: boolean | null;
    clientMutationId?: string | null;
};
export type AddressInput = {
    active?: boolean | null;
    addressBookMember?: boolean | null;
    contact?: string | null;
    city?: string | null;
    company?: string | null;
    country?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    label?: string | null;
    line1?: string | null;
    line2?: string | null;
    phoneNumber?: string | null;
    state?: string | null;
    zipCode?: string | null;
};
export type dblUserAddAddressMutationVariables = {
    input: UserAddAddressInput;
};
export type dblUserAddAddressMutationResponse = {
    readonly userAddAddress: {
        readonly address: {
            readonly serviceId: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
        } | null;
    } | null;
};
export type dblUserAddAddressMutation = {
    readonly response: dblUserAddAddressMutationResponse;
    readonly variables: dblUserAddAddressMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserAddAddressInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "dblUserAddAddressMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userAddAddress",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "address",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "dblUserAddAddressMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userAddAddress",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "address",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "dblUserAddAddressMutation",
    "id": "app-buyer-finding/293.0.0-2020-12-09T21:42:09.926Z/dblUserAddAddressMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '07798d83253ef0d6fb8af14aff716c81';
export default node;
